<!--  -->
<template>
  <div class="bigBox">
    <div class="w1200">
      <div class="row">
        <div class="left">
          <div class="title">我们的核心业务</div>
          <div class="content">
            专业从事互联网服务,适用于PC,小程序,微信等专业的开发技术团队让您的产品快速启动,完美落地。
          </div>
          <div class="secImg">
            <div class="secImgList">
              <img class="img-fluid" src="@/assets/weixin1.png" />
              <div class="tit">微信/小程序</div>
            </div>
            <div class="secImgList">
              <img class="img-fluid" src="@/assets/ruanjianfuwu.png" />
              <div class="tit">软件开发</div>
            </div>
            <div class="secImgList">
              <img class="img-fluid" src="@/assets/diannao.png" />
              <div class="tit">高端网站建设</div>
            </div>
          </div>
        </div>
        <div class="right">
          <img src="@/assets/xm.png" >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  name: "HomeTop",
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  created() {},
};
</script>
<style lang="less" scoped>
.row {
  width: 100%;
  height: 400px;
  display: flex;
  margin-top: 50px;
  .left {
    width: 50%;
    height: 400px;
    .title {
      font-size: 3rem;
      color: #000000;
      font-family: "syhtm";
      margin-bottom: 15px;
    }
    .content {
      height:100px;
      line-height: 36px;
      font-size:16px;
      color: #000000;
      margin-bottom: 15px;
      margin-right: 20px;
    }
    .secImg {
      width: 90%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .secImgList {
        text-align: center;
        padding-right: 5rem;
        padding-left: 0;
        margin-bottom: 5rem;
        .img-fluid {
          height: 3.625rem;
          min-height: 50px;
          margin-bottom: 10px;
        }
        .txt {
          white-space: nowrap;
          font-size: 18px;
          color: #000000;
          font-family: microsoft yahei;
          text-align: center;
        }
      }
    }
  }
  .right {
    width: 50%;
    height: 400px;
    overflow: hidden;
    img{
      display: inline-block;
      width:100%;
      height: 400px;
      cursor: pointer;
      transition: all .6s;
    }
  }
  .right{
    img:hover{
       transform: scale(1.2);
    }
  }
}
</style>